import React from "react";
import { Dropdown } from "semantic-ui-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import CustomDropdown from "components/CustomDropdown";
import withRoleCheck from "components/hocs/withRoleCheck";
import { IncludeContactsModal as _IncludeContactsModal } from "components/modals/IncludeContactsModal";
import { RemoveCampaignModal as _RemoveCampaignModal } from "components/modals/RemoveCampaignModal";

const IncludeContactsModal = withRoleCheck(_IncludeContactsModal, [
  ACL_RELATIONSHIPS.campaignTargetContacts.create,
]);
const RemoveCampaignModal = withRoleCheck(_RemoveCampaignModal, [
  ACL_RELATIONSHIPS.campaignTarget.delete,
]);

export const CampaignTableActions = ({
  entityId,
  original,
  invalidateData,
  handleRemoveCampaignView,
}) => {
  return (
    <CustomDropdown icon="ellipsis horizontal">
      <Dropdown.Menu direction="left">
        {!!entityId && (
          <IncludeContactsModal
            entityId={original?.entity_id}
            campaignId={original?.campaign_id}
            onSuccess={invalidateData}
          />
        )}
        <RemoveCampaignModal
          menuTrigger
          campaignName={original?.campaign_name}
          modelType={original?.contact_id ? "contact" : "entity"}
          onConfirmDelete={async () =>
            await handleRemoveCampaignView({
              campaign_id: original?.campaign_id,
              entity_id: original?.entity_id,
              contact_id: original?.contact_id,
            })
          }
        />
      </Dropdown.Menu>
    </CustomDropdown>
  );
};
